import {
  Blog03,
  Blog03M,
  Blog03T,
  Blog32,
  Blog32M,
  Blog32T,
  Blog34,
  Blog34M,
  Blog34T,
  Blog62,
  Blog62M,
  Blog62T,
  Blog63,
  Blog63M,
  Blog63T,
  Blog84,
  Blog84M,
  Blog84T,
} from '@assets/images/blog';

export default {
  //////// Nội dung giải pháp /////////

  constructionSafety: {
    tag: 'Giải pháp',
    title: 'Quản lý an toàn công nhân',
    desc: 'An toàn của công nhân là điều quan trọng nhất. Không đảm bảo an toàn trong môi trường nguy hiểm cao có thể ảnh hưởng đến năng suất và dẫn đến trách nhiệm pháp lý.',
    link: '/vi/enterprise/construction/safety',
  },

  constructionAsset: {
    tag: 'Giải pháp',
    title: 'Theo dõi và quản lý vị trí vật liệu xây dựng',
    desc: 'Quản lý vật liệu chính xác sẽ nâng cao năng suất. Giảm lãng phí, duy trì chất lượng và đảm bảo an toàn – quản lý vật liệu là yếu tố then chốt trên công trường.',
    link: '/vi/enterprise/construction/asset',
  },

  constructionEquipment: {
    tag: 'Giải pháp',
    title: 'Quản lý thiết bị hạng nặng',
    desc: 'Thiết bị nặng là yếu tố cốt lõi trên công trường. Bảo trì đúng cách và ngăn ngừa tai nạn là bắt buộc. Quản lý tốt thiết bị giúp giảm chi phí, tăng an toàn và cải thiện rõ rệt năng suất.',
    link: '/vi/enterprise/construction/equipment',
  },

  logisticsAsset: {
    tag: 'Giải pháp',
    title: 'Theo dõi và quản lý vị trí tồn kho',
    desc: 'Quản lý kho hàng hỗ trợ hiệu quả chuỗi cung ứng và vận hành trơn tru. Biết chính xác vị trí tồn kho theo thời gian thực giúp giám sát và tối ưu hóa luồng hàng.',
    link: '/vi/enterprise/logistics/asset',
  },

  logisticsSafety: {
    tag: 'Giải pháp',
    title: 'Quản lý an toàn cho nhân viên kho',
    desc: 'An toàn của công nhân luôn quan trọng. Không chỉ ảnh hưởng đến năng suất, mà còn có thể dẫn đến trách nhiệm pháp lý. Môi trường kho an toàn cũng xây dựng uy tín và niềm tin cho doanh nghiệp.',
    link: '/vi/enterprise/logistics/safety',
  },

  retailOffice: {
    tag: 'Giải pháp',
    title: 'Quản lý tài sản',
    desc: 'Quản lý tài sản kém hiệu quả gây thiệt hại về thời gian và chi phí. Quản lý nhanh chóng, rõ ràng giúp doanh nghiệp vận hành suôn sẻ.',
    link: '/vi/enterprise/retail/office',
  },

  manufacturingProcess: {
    tag: 'Giải pháp',
    title: 'Quản lý quy trình sản xuất theo thời gian thực',
    desc: 'Giám sát toàn bộ quy trình sản xuất một cách trực quan. Dữ liệu chính xác giúp cải thiện dây chuyền, nâng cao hiệu quả – yếu tố cốt lõi của ngành sản xuất.',
    link: '/vi/enterprise/manufacturing/process',
  },

  manufacturingSteel: {
    tag: 'Giải pháp',
    title: 'Quản lý kho hàng theo thời gian thực',
    desc: 'Nhà máy lưu trữ nhiều nguyên liệu và bán thành phẩm. Quản lý đúng cách là yếu tố quan trọng đối với khả năng tiết kiệm thời gian và chi phí, ảnh hưởng trực tiếp đến hiệu quả sản xuất.',
    link: '/vi/enterprise/manufacturing/steel',
  },

  medicalPatient: {
    tag: 'Giải pháp',
    title: 'Theo dõi vị trí bệnh nhân',
    desc: 'Trong cơ sở y tế có những bệnh nhân cần được quản lý chặt chẽ. Không cần giám sát 24/7 bằng mắt thường; hệ thống theo dõi vị trí thời gian thực sẽ cung cấp thông tin nhanh chóng và chính xác.',
    link: '/vi/enterprise/medical/patient',
  },

  medicalWaste: {
    tag: 'Giải pháp',
    title: 'Quản lý chất thải y tế',
    desc: 'Theo dõi vị trí và tình trạng chất thải y tế thời gian thực để ngăn ngừa tai nạn và đảm bảo dịch vụ y tế an toàn. Tuân thủ quy định pháp luật, bảo vệ sức khỏe con người và tài nguyên.',
    link: '/vi/enterprise/medical/waste',
  },

  retailExhibition: {
    tag: 'Giải pháp',
    title: 'Quản lý và phân tích khách tham quan triển lãm',
    desc: 'Phân tích lộ trình khách tham quan và quản lý tài sản dễ dàng giúp vận hành hiệu quả. Dữ liệu chính xác và khách quan hỗ trợ phát triển kinh doanh.',
    link: '/vi/enterprise/retail/exhibition',
  },

  //////// Nội dung blog /////////

  blogConstruction: {
    tag: 'Blog',
    title: 'Tương lai ngành xây dựng với RTLS',
    desc: 'Ngành xây dựng, giống như nhiều lĩnh vực khác, luôn tìm cách nâng cao hiệu quả, sản lượng và độ an toàn. Các công ty dẫn đầu đang ứng dụng công nghệ tiên tiến để giải quyết những thách thức này.',
    link: '/vi/blog/rtls',
  },

  blogRTLS: {
    tag: 'Blog',
    title: 'Ứng dụng RTLS tại công trường xây dựng',
    desc: 'Tìm hiểu cách sử dụng hệ thống RTLS để xác định vị trí bên trong công trình và tối ưu di chuyển. Nhiều công ty xây dựng đang triển khai hệ thống theo dõi để nâng cao hiệu quả và tiết kiệm thời gian.',
    link: '/vi/blog/rtls',
  },

  blogActiveRfid: {
    tag: 'Blog',
    title: 'RTLS dựa trên công nghệ Active RFID',
    desc: 'Active RFID là dạng truyền thông không dây giữa các thiết bị, với nguồn cung cấp điện riêng, cho phạm vi truyền tín hiệu xa. Lý tưởng cho theo dõi tài sản thời gian thực.',
    link: '/vi/blog/activerfid',
  },

  blogForklift: {
    tag: 'Blog',
    title: 'Giải pháp RTLS cải thiện an toàn cho lái xe nâng',
    desc: 'Xe nâng cần kiểm tra hàng ngày để đảm bảo hoạt động tốt: phanh đỗ, đèn chiếu sáng, mức dầu thủy lực, v.v. Mọi hỏng hóc phải được khắc phục ngay, và ít nhất một lần mỗi tháng kỹ thuật viên có chứng chỉ nên thực hiện kiểm tra chi tiết.',
    link: '/vi/blog/forklift',
  },

  blogOffice: {
    tag: 'Blog',
    title: 'Xây dựng văn phòng thông minh năm 2023',
    desc: 'Định vị trong nhà tại văn phòng gây nhiều khó khăn: với nhiều tầng và phòng, khách dễ lạc đường. Sử dụng bản đồ thông minh giúp cải thiện trải nghiệm và nâng cao sự hài lòng của khách tham quan.',
    link: '/vi/blog/office',
  },

  blogFactory: {
    tag: 'Blog',
    title: 'Chào mừng đến với nhà máy tương lai: Vai trò của theo dõi thời gian thực trong Industry 4.0',
    desc: 'Tương lai nhà máy sẽ trải qua những đổi mới đột phá, dựa trên IoT, AI và Big Data. RTLS cũng là yếu tố then chốt dẫn dắt sự đổi mới này.',
    link: '/vi/blog/factory',
  },

  blogMedical: {
    tag: 'Blog',
    title: 'RTLS trong ngành y tế',
    desc: 'Sau đại dịch, công nghệ IT trong y tế càng trở nên quan trọng. Việc theo dõi và quản lý bệnh nhân là trọng tâm. RTLS sẽ được ứng dụng rộng rãi, nâng cao chất lượng dịch vụ y tế trong tương lai.',
    link: '/vi/blog/medical',
  },

  contents: {
    title: 'Blog',
    desc: '',
    request: '',
    card: [
      {
        img: '',
        title: 'Theo dõi vị trí thời gian thực cho quản lý bệnh nhân',
        desc: 'Quản lý bệnh nhân an toàn, hiệu quả nhờ theo dõi vị trí thời gian thực.',
        link: '/vi/blog/patientTracking',
        bgImg: {
          desktop: Blog34,
          tablet: Blog34T,
          mobile: Blog34M,
        },
      },
      {
        img: '',
        title: 'Hệ thống quản lý an toàn công trường thông minh',
        desc: 'Giải pháp thông minh giúp ngăn ngừa tai nạn và tối ưu quản lý công trường.',
        link: '/vi/blog/smartConstruction',
        bgImg: {
          desktop: Blog32,
          tablet: Blog32T,
          mobile: Blog32M,
        },
      },
      {
        img: '',
        title: 'Digital Twin và hệ thống định vị thời gian thực',
        desc: 'Kết hợp Digital Twin và RTLS để trực quan hóa vị trí không gian và tài sản.',
        link: '/vi/blog/digitalTwin',
        bgImg: {
          desktop: Blog03,
          tablet: Blog03T,
          mobile: Blog03M,
        },
      },
      {
        img: '',
        title: 'Giải pháp nhà máy thông minh & tự động hóa',
        desc: 'Tối ưu hiệu suất sản xuất với tự động hóa và công nghệ nhà máy thông minh.',
        link: '/vi/blog/productionAutomation',
        bgImg: {
          desktop: Blog63,
          tablet: Blog63T,
          mobile: Blog63M,
        },
      },
      {
        img: '',
        title: 'Chuyển đổi số là gì?',
        desc: 'Tìm hiểu khái niệm và cách áp dụng chuyển đổi số để nâng cao sức cạnh tranh.',
        link: '/vi/blog/what-is-digital-transformation',
        bgImg: {
          desktop: Blog84,
          tablet: Blog84T,
          mobile: Blog84M,
        },
      },
      {
        img: '',
        title: 'UWB RTLS: Khởi đầu cho công nghiệp tương lai',
        desc: 'Áp dụng công nghệ UWB RTLS để theo dõi chính xác và xây dựng môi trường công nghiệp hiện đại.',
        link: '/vi/blog/uwbRtls',
        bgImg: {
          desktop: Blog62,
          tablet: Blog62T,
          mobile: Blog62M,
        },
      },
    ],
  },
};
